type CampaignBudgetExhaustedInput = {
  remainingCents?: number | null;
  totalCents?: number | null;
};

export function isCampaignBudgetExhausted({
  remainingCents,
  totalCents,
}: CampaignBudgetExhaustedInput): boolean {
  if (typeof remainingCents !== 'number' || !Number.isFinite(remainingCents)) {
    return false;
  }
  if (typeof totalCents === 'number' && Number.isFinite(totalCents) && totalCents <= 0) {
    return false;
  }
  return remainingCents <= 0;
}
